import { Component, Input } from '@angular/core';

@Component({
    selector: 'working-time-schema-popup',
    templateUrl: 'working-time-schema-popup.component.html',
    styleUrls: ['working-time-schema-popup.component.scss']
})

export class WorkingTimeSchemaPopupComponent {
  public defaultStartHour = '00:00';
  public defaultEndHour = '23:59';
  
  @Input() top: string = '0px';
  @Input() left: string = '0px';
  @Input() isCompany: boolean = false;
  @Input() workingTimeSchema: any;
}
